import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import SpinnerLoader from '../../../Utils/Spinner.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import { formatDateDDMMYYYYHHMMSS, formatDateDDMMYYYYHHMMSS_UTC } from '../../../Utils/data&dateTime.js';
import { handlePrintReceipt } from '../../../Utils/PrintTransactionReceiptien.js';
import { highlightMatch } from '../../../Utils/highlightSearchFunctions.js';
import TableLoaderOverlay from '../../../Utils/tableFadingLoader.js';

export const ReceiveTransactions = ({ handleRowClick, formattedData, isLoading, selectedTxnDetails, handlePageChange, currentPage, isSearchLoading, pageCounts, filterLoading,filterQueryStringFeeReceive ,tableLoading,showSpinner}) => {

 

        const searchValue = new URLSearchParams(filterQueryStringFeeReceive).get("search") || "";
    const columns = useMemo(
        () => [
            {
                Header: "Receiving ID",
                accessor: "transaction_id",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: "pointer" }}
                        onClick={() => handleRowClick(row.original.id, row)}
                    >
                        <p
                            style={{
                                textAlign: "left",
                                color: "#222F3E",
                                fontWeight: 500,
                                margin: 0,
                            }}
                               dangerouslySetInnerHTML={{
                                __html: highlightMatch(
                                    row.original.transaction_id?.toString() || "-",
                                    searchValue
                                ),
                            }}
                        >
                            {/* {row.original.transaction_id} */}

                            
                        </p>
                    </div>
                ),
            },
            {
                Header: "Receiving Date/Time",
                accessor: "payment_date",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div>
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                            {formatDateDDMMYYYYHHMMSS_UTC(row.original.payment_date)}
                        </p>
                    </div>
                ),
            },
            {
                Header: "Student name/Reg Id",
                accessor: "student_name",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }}>
                            {row.original.student_name}
                        </p>
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }}>
                            {row.original.permanent_registration_number}
                        </p>
                    </div>
                ),
            },
            {
                Header: "Course",
                accessor: "course_name",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }}>
                            {row.original.course_name}
                        </p>
                    </div>
                ),
            },
            {
                Header: "Admission Academic Year",
                accessor: "academic_year",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }}>
                            {row.original.academic_year}
                        </p>
                    </div>
                ),
            },

            {
                Header: "Mode Of Payment",
                accessor: "payment_method",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div>
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                            {row.original.payment_method}
                        </p>
                    </div>
                ),
            },
            {
                Header: () => <p style={{ textAlign: "right" }}>Amount</p>,
                accessor: "amount",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: "right", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                        <p style={{ textAlign: "right", color: "#222F3E", margin: 0 }}>
                            {row.original.amount.toFixed(2)}
                        </p>
                    </div>
                ),
            },
            {
                Header: "Status",
                accessor: "payment_status",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div style={{ textAlign: "left", color: "#222F3E", margin: 0 }} className="no-text-cursor">
                        <p style={{ textAlign: "left", color: "#222F3E", margin: 0 }}>
                            {row.original.payment_status}
                        </p>
                    </div>
                ),
            }, 
            {
                Header: "Action",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        className="d-flex justify-content-center"
                        style={{ cursor: "pointer" }}
                        data-tooltip-id="print-tip"
                        title="Print Receipt"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#7F56DA"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handlePrintReceipt(row)}
                            data-tooltip-id="admission-tip"
                            data-tooltip-content="Print Receiving"
                        >
                            <path d="M6 9V2h12v7" />
                            <path d="M6 18H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
                            <rect x="6" y="14" width="12" height="8" />
                            <title>Print Receiving</title>
                        </svg>
                    </div>
                ),
            },
        ],
        [handleRowClick, searchValue]
    );


    return (
    <>
        {isLoading ? (
            <SpinnerLoader />
        ) : (
            <div style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                minHeight: 0,
                overflow: "hidden",
            }}>
                {(filterLoading || showSpinner) ? (
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                    }}>
                        <SpinnerLoader />
                    </div>
                ) : formattedData?.length > 0 ? (
                    <AdvanceTable
                        columns={columns}
                        pageCounts={pageCounts}
                        handlePageChange={handlePageChange}
                        selectedData={selectedTxnDetails}
                        data={formattedData}
                        handleRowClick={handleRowClick}
                        currentPage={currentPage}
                        checkbox={false}
                        rowClassName="small-row"
                    />
                ) : (!isLoading && !isSearchLoading && (
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        flex: 1,
                        color: "#888",
                        textAlign: "center",
                    }}>
                        No Fee available.
                    </div>
                ))}
            </div>
        )}
    </>
);
};

